import { CircularProgress } from '@mui/material';

import styles from './Loading.module.css';

interface ApplicationSpinnerProps {
	width?: string | number;
	height?: string | number;
	spinnerSize?: number;
}

export default function ApplicationSpinner(props: ApplicationSpinnerProps) {
	return (
		<div
			className={styles.spinner}
			style={{
				width: props.width,
				height: props.height
			}}
		>
			<CircularProgress size={props.spinnerSize} />
		</div>
	);
}
